import { css } from "@emotion/react";
import React from "react";
import { Helmet } from "react-helmet";
import { AsOf } from "../../../shared/AsOf";
import { DownloadsLabel } from "../../../shared/DownloadsLabel";
import { useAccount } from "../../../store/account";

const reports = {
    episode: "Episode",
    client: "Client",
    country: "Country"
};
const periods = {
    day: "Daily",
    week: "Weekly",
    month: "Monthly",
    quarter: "Quarterly",
    year: "Yearly"
};

export default function ReportTitle({ makeUrl, report, period, podcast, reportStart, reportEnd }) {
    const { pending: isLoading, data: account } = useAccount();
    const downloadsLabel = DownloadsLabel();
    return (
        <>
            <Helmet>
                <title>{downloadsLabel} {report ? `by ${reports[report]}` : ""} - Podtrac</title>
            </Helmet>
            <div
                css={css`
                    display: flex;
                    align-items: center;
                    & > h1 {
                        margin: 1rem 0 0 0;
                        flex: 1;
                    }
                `}
            >
                <h1>
                    {periods[period]} <DownloadsLabel />:{" "}
                    <span style={{ fontWeight: "normal" }}>{reports[report]}</span>
                </h1>
                {/*<ReportNav makeUrl={makeUrl} />*/}
            </div>
            {/*<div
                css={css`
                    display: flex;
                    align-items: center;
                    & > h1 {
                        flex: 1;
                    }
                `}
            >
                <h1
                    css={css`
                        font-size: 2.25rem;
                        font-weight: 300;
                        color: #f0592b;
                        margin: 0.2em 0;
                    `}
                >
                    {podcast ? podcast.title : <span style={{ color: "#999" }}>…</span>}
                </h1>
            </div>*/}
            <div style={{ fontSize: "0.75rem" }}>
                {podcast ? <AsOf date={podcast.lastRunDate} /> : "…"}
            </div>
        </>
    );
}
